import {
  positionPopover,
  computeArrowOffset,
  type Alignment,
  type Placement,
  type Offset,
} from '@repo/lib/position';

export interface FloatingPositionConfig {
  floating: HTMLElement;
  trigger: { getBoundingClientRect(): DOMRect };
  arrow: HTMLSpanElement | null;
  placement: Placement;
  align: Alignment;
  offset: Offset;
  viewportMargin: number;
  hasArrow: boolean;
}

export const applyFloatingPosition = (config: FloatingPositionConfig) => {
  const {
    floating,
    trigger,
    arrow,
    placement,
    align,
    offset,
    viewportMargin,
    hasArrow,
  } = config;

  const triggerRect = trigger.getBoundingClientRect();

  floating.dataset.align = align;
  floating.dataset.placement = placement;

  const floatingRect = floating.getBoundingClientRect();

  const { position, flip } = positionPopover(
    triggerRect,
    floatingRect,
    placement,
    align,
    { offset, viewportMargin },
  );

  floating.style.top = `${position.y}px`;
  floating.style.left = `${position.x}px`;

  if (flip.placement) {
    floating.dataset.placement = flip.placement;
  }

  if (!hasArrow || !arrow) return;

  const finalPlacement = flip.placement ?? placement;

  const arrowOffset = computeArrowOffset({
    triggerRect,
    popoverRect: floatingRect,
    position,
    finalPlacement,
  });

  arrow.style.left = '';
  arrow.style.top = '';

  if (finalPlacement === 'top' || finalPlacement === 'bottom') {
    arrow.style.left = `${arrowOffset}px`;
  } else {
    arrow.style.top = `${arrowOffset}px`;
  }
};
